import mutations from '@root/src/javascripts/store/mutation-types'
import { getMutationType } from '@lib/mutation-types/index'

export default {
  created() {
    for (const fieldName in this.form) { // eslint-disable-line
      this.$watch(`form.${fieldName}`, (newValue) => {
        const mutationType = getMutationType(fieldName, mutations)
        if (mutationType) {
          this.$store.commit(mutationType, newValue)
        }
      })
    }
  },
}
